import { Substitutions } from "./paywall";
export const parseWebPaywall = (paywall)=>{
    const substitutions = paywall.substitutions ? Substitutions.parse(paywall.substitutions).substitutions : [];
    //@ts-ignore
    return {
        ...paywall,
        ...typeof paywall.substitutions != "undefined" ? {
            substitutions
        } : {}
    };
};
